import React from 'react'
import { connect } from 'react-redux'
import { AppState } from '@chegg-wt/core/state'

import { modalDataSelector } from '@chegg-wt/core/state/modals/selectors'
import { Modal } from '..'
import DeleteFolderModal from './DeleteFolderModal'
import DeleteCitationsModal from './DeleteCitationsModal'

const DeleteModals = {
  folder: DeleteFolderModal,
  citations: DeleteCitationsModal,
}

export const DeleteModal = ({ modalData }) => {
  const SelectedModal = DeleteModals[modalData.resourceType] || null
  return (
    <Modal showModal closeButton outsideClick>
      <SelectedModal modalData={modalData} />
    </Modal>
  )
}

const mapStateToProps = (state: AppState) => ({
  modalData: modalDataSelector(state),
})

export default connect(mapStateToProps)(DeleteModal)
